import { last, get } from 'lodash-es';
import { getFullImageUrl, getYoutubePreviewImage, YOUTUBE_PREVIEW_SIZE } from 'client/utils/image-helpers';

export function getVideoSchema(videoObject, { noTranscript } = {}) {
  const {
    videoDescription,
    videoTitle,
    uploadDate,
    thumbnailURL,
    videoTranscript,
    videoId,
    'youtube-videoid': youtubeVideoId,
    googleThumbnail,
  } = videoObject;
  const transcript = noTranscript ? undefined : videoTranscript;
  const description = videoDescription || transcript;
  const thumbnail = googleThumbnail || thumbnailURL;
  const video = videoId || youtubeVideoId;

  // Return null if we can't fill in required fields
  if (!videoTitle || !(thumbnail || video) || !uploadDate) return null;

  return {
    '@type': 'VideoObject',
    description,
    name: videoTitle,
    transcript,
    thumbnailUrl: thumbnail ? getFullImageUrl(thumbnail) : getYoutubePreviewImage(video, YOUTUBE_PREVIEW_SIZE.HQ),
    contentUrl: `https://www.youtube.com/watch?v=${video}`,
    uploadDate,
  };
}

export function getEditorialVideoSchema(video) {
  const { title, url, publishDate } = video;
  const videoId = last(url.split('/'));
  const thumbnailURL = getYoutubePreviewImage(videoId, YOUTUBE_PREVIEW_SIZE.HQ);

  return getVideoSchema({
    videoTitle: title,
    uploadDate: publishDate,
    videoId,
    thumbnailURL,
    videoDescription: title,
  });
}

export function getItemListVideoSchema(videos, { noTranscript } = {}) {
  return {
    '@type': 'ItemList',
    itemListElement: videos.map((video, index) => {
      const videoSchema = getVideoSchema(video, { noTranscript });

      return { ...videoSchema, position: index + 1, url: get(videoSchema, 'contentUrl') };
    }),
  };
}
